import { Box } from '@mui/material'

import Dialog from '~/features/chatbot/components/dialog'
import Header from '~/features/chatbot/components/simple/header'

function Simple() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: { xxxs: 'column', md: 'row' },
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Header />
      <Dialog />
    </Box>
  )
}

export default Simple
